import { createFileRoute } from '@tanstack/react-router'
import { UserManagementPage } from '@/features/user-management'
import { requireAccess } from '@/app/router/route-guards'
import { Permission } from '@/lib/rbac'

export const Route = createFileRoute('/_auth/user-management')({
  beforeLoad: () => requireAccess({ permission: Permission.UserManage }),
  component: UserManagementPage,
})
